module.exports = __webpack_public_path__ + "static/img/logos.f8ebc0f4.png";